<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    movCteList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },
  mounted() {
    // console.log('mounted condicoes-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        case 'EL':
          result = 'Elaboraçao'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.$router.push(`/movcte/editar/${dataID}`)

    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        this.$emit('alterareg', this.regSelecionado)
      }
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.submitted = false
      this.showModal = true
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap" v-if="movCteList">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Número / Emissão / Previsão</th>
        <th class="align-middle">Transportador</th>
        <th class="align-middle">Remetente</th>
        <th class="align-middle">Destinatário</th>
        <th class="align-middle text-end">Valor</th>
        <th class="align-middle text-end">Peso</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in movCteList" :key="data.id">
        <td>
          <a href="javascript: void(0);"
             class="text-body fw-bold"
             @click="editar(data.id)">{{ data.id }}
          </a>
        </td>
        <td>{{ data.numero }}
          <br>
          {{ formatDate(data.dtemissao) }}
          <br>
          {{ formatDate(data.dtpreventr) }}

        </td>


        <td class="text-wrap" style="min-width: 200px;">
          <span class="text-info"> {{ data.nomeemit }} </span>
          <br>
            <span class="text-opacity-50">
            {{ data.cnpjemit }}
            </span>
          <br>
            <span class="text-black">
            {{ data.cidadeemit }} / {{ data.estadoemit }}
            </span>
        </td>

        <td class="text-wrap" style="min-width: 200px;">
          <span class="text-info"> {{ data.nomeremet }} </span>
          <br>
          <span class="text-opacity-50">
            {{ data.cnpjremet }}
            </span>
          <br>
          <span class="text-black">
            {{ data.cidaderemet }} / {{ data.estadoremet }}
            </span>
        </td>

        <td class="text-wrap" style="min-width: 200px;">
          <span class="text-info"> {{ data.nomedest }} </span>
          <br>
          <span class="text-opacity-50">
            {{ data.cnpjdest }}
            </span>
          <br>
          <span class="text-black">
            {{ data.cidadedest }} / {{ data.estadodest }}
            </span>
        </td>


        <td class="text-end">{{ formatDecimal(data.valor) }} </td>
        <td class="text-end">{{ formatDecimal(data.peso) }} </td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'FA' ? 'badge-soft-success' :
                          data.status === 'EL' ? 'badge-soft-warning' :
                          data.status === 'CO' ? 'badge-soft-info' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td>
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>


  </div>

</template>
